import { render } from "./teacher-checking-selector.vue?vue&type=template&id=6a0843e4&scoped=true"
import script from "./teacher-checking-selector.vue?vue&type=script&lang=js"
export * from "./teacher-checking-selector.vue?vue&type=script&lang=js"

import "./teacher-checking-selector.vue?vue&type=style&index=0&id=6a0843e4&lang=scss&scoped=true"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a0843e4"]])

export default __exports__